import { REFRESH_URL } from '../Api'
import { logOut } from './Logout'

export const refreshToken = (setTokens, setUsername) => {
    const refreshTokenFromStorage = localStorage.getItem('refreshToken')
    if(refreshTokenFromStorage !== undefined && refreshTokenFromStorage !== null) {
        const payload = {"refresh": refreshTokenFromStorage}
        fetch(REFRESH_URL, {
            method: 'post',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify(payload)
        }).then(response=>{ return response.json() })
        .then(response=>{
            if(response.access !== undefined) {
                const newAccessToken = response.access
                const tokensToStore = {access: newAccessToken, refresh: refreshTokenFromStorage}
                setTokens(tokensToStore)
                localStorage.setItem('accessToken', newAccessToken)
            } else if(response.code === "token_not_valid") {
                logOut(setTokens, setUsername)
            } else {
                logOut(setTokens, setUsername)
            }
        })
    }
}
